// extracted by mini-css-extract-plugin
module.exports = {"topBarTooltip":"styles_topBarTooltip__Y6t_a","tippy-box":"styles_tippy-box__QpwSk"};